import { render, staticRenderFns } from "./TermGraph.vue?vue&type=template&id=e6819488&scoped=true&"
import script from "./TermGraph.vue?vue&type=script&lang=js&"
export * from "./TermGraph.vue?vue&type=script&lang=js&"
import style0 from "./TermGraph.vue?vue&type=style&index=0&id=e6819488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6819488",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib'
installComponents(component, {VRow})
